import microOrgs from '@/sui/data/microOrgs'
import go from '@/gojs/go'

function getDeathDate (p) {
  if (p.dead === 1) {
    return p.exit
  }
  return null
}

function getExitDate (p) {
  if (p.dead !== 1) {
    return p.exit
  }
  return null
}

function getValue (v, good) {
  if (good.indexOf(v) !== -1) {
    return v
  }
  return null
}

function getSeverity (o) {
  if (o == null || o === '') {
    return null
  }
  return { 'code': 'igsII', 'value': o }
}

function getMicroCode (code, list) {
  const c = code.indexOf(' ') !== 3
    ? `${code.slice(0, 3)} ${code.slice(3, 6)}` : code
  const m = list.find((m) => m.code === c)
  return m != null ? m.index : null
}

function newDate (date) {
  if (date == null || date === '') {
    return null
  }

  const values = date.split('/')
  const day = parseInt(values[0], 10)
  const month = parseInt(values[1], 10)
  const year = parseInt(values[2], 10)
  return new Date(year, month - 1, day, 10)
}

function createPatient (p) {
  return {
    sheetNumber: p.sheetNumber,
    uf: p.uf,
    birthdate: newDate(p.birthdate),
    sex: getValue(p.sex, [1, 2, 3, 9]),
    entry: newDate(p.entry),
    mainSeverity: getSeverity(p.igsII),
    catheters: [],
    bacteremias: [],
    dead: getValue(p.dead, [1, 2, 9]),
    death: newDate(getDeathDate(p)),
    exit: newDate(getExitDate(p))
  }
}

function getOrigin (origin) {
  const value = parseInt(origin, 10)
  if (!isNaN(value)) {
    return getValue(value, [0, 1, 2, 3, 4, 5, 6, 7, 9])
  }

  const o = go.fields2019.origins.find(
    i => i.code.toLowerCase() === origin.toLowerCase()
  )
  if (o != null) {
    return o.index
  }
  return null
}

const patientValues = [
  { f: 'antibio', c: (v) => getValue(v, [1, 2, 9]) },
  { f: 'diagnosis', c: (v) => getValue(v, [1, 2, 3, 9]) },
  { f: 'immuno', c: (v) => getValue(v, [1, 2, 3, 9]) },
  { f: 'origin', c: (v) => getOrigin(v) },
  { f: 'trauma', c: (v) => getValue(v, [1, 2, 9]) }
]

function extractPatientField (target, field, value) {
  extractField(patientValues, target, field, value)
}

function extractField (choices, target, field, value) {
  const f = choices.find(p => p.f === field)
  if (f != null) {
    const targettedField = f.t != null ? f.t : field
    target[targettedField] = f.c(value)
  }
}

function createCVC (cvc) {
  return {
    central: 1,
    type: getValue(cvc.type, [1, 2, 3, 4, 5, 6, 9]),
    insertion: newDate(cvc.insertion),
    removed: getValue(cvc.removed, [1, 2, 9]),
    removal: newDate(cvc.removal)
  }
}

const bactValues = [
  { f: 'bactEpisod', t: 'episod', c: newDate },
  { f: 'bactOrigin', t: 'origin', c: (v) => getValue(v, [1, 2, 3, 4, 5]) },
  {
    f: 'bactEntrance',
    t: 'entrance',
    c: (v) => getValue(
      v,
      [
        1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
        22, 23
      ]
    )
  },
  { f: 'bactInsertion', t: 'insertion', c: newDate },
  {
    f: 'bactInsertionSite',
    t: 'insertionSite',
    c: (v) => getValue(v, [1, 2, 3, 4, 5, 6, 7, 8, 9])
  },
  { f: 'bactRemoved', t: 'removed', c: (v) => getValue(v, [1, 2, 9]) },
  { f: 'bactRemoval', t: 'removal', c: newDate }
]

function extractBactField (target, field, value) {
  if (field.startsWith('bactMO')) {
    const index = parseInt(field.substring('bactMO'.length), 10)
    if (index < 0) {
      throw new Error(`field ${field}, invalid index ${index}`)
    } else if (target.microOrganisms.length !== index - 1) {
      throw new Error(
        `field ${field}, invalid index ${index},
${target.microOrganisms.length}`
      )
    }
    const code = getMicroCode(value, microOrgs.list)
    if (code == null) {
      throw new Error(
        `field ${field}, invalid code ${value}`
      )
    }

    target.microOrganisms.push({ code: code, antibio: [] })
  } else if (field.startsWith('bactResist')) {
    const index = parseInt(field.substring('bactResist'.length), 10)
    if (index < 0) {
      throw new Error(`field ${field}, invalid index ${index}`)
    } else if (target.microOrganisms.length !== index) {
      throw new Error(
        `field ${field}, invalid index ${index},
${target.microOrganisms.length}`
      )
    }

    let rlist = []
    const split = value.split(' ')
    split.forEach(
      (s) => {
        const v = s.split(':')
        if (v.length === 2) {
          const field = v[0].toLowerCase()
          const resistance = microOrgs.resistances.find(
            r => r.field === field
          )
          if (resistance != null) {
            const value = resistance.values.find(
              i => i.code === v[1] || i.alt === v[1]
            )
            if (value != null) {
              rlist.push(
                {
                  code: resistance.index,
                  resistance: value.index
                }
              )
            }
          }
        }
      }
    )
    target.microOrganisms[index - 1].antibio = rlist
  } else {
    extractField(bactValues, target, field, value)
  }
}

export default {
  createPatient: createPatient,
  extractPatientField: extractPatientField,
  createCVC: createCVC,
  extractBactField: extractBactField
}
